module.exports = __webpack_public_path__ + "static/media/shopper.74e4c47e.png";